import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProgramBuilder from './pages/ProgramBuilder';
import OptionsSelection from './pages/OptionsSelection';
import ContactForm from './pages/ContactForm';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './App.css';

function App() {
  return (
    <div className="App">
      <DndProvider backend={HTML5Backend}>
        <Router>
          <Routes>
            <Route path="/" element={<ProgramBuilder />} />
            <Route path="/options" element={<OptionsSelection />} />
            <Route path="/contact" element={<ContactForm />} />
          </Routes>
        </Router>
      </DndProvider>
    </div>
  );
}

export default App;